function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 5,
  width: 12,
  height: 1.5,
  rx: 0.5,
  fill: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 9.5,
  width: 12,
  height: 1.5,
  rx: 0.5,
  fill: "#00BB77"
});
const SvgEqual = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEqual, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equal.a8f259d5.svg";
export { ForwardRef as ReactComponent };